import React, { useEffect } from 'react';

// Shown to a logged-in, confirmed user who is NOT entitled to nesting downloads
// (Starter or free/no-credit, off the demo). Replaces the DXF/SVG/PDF buttons with a
// single "Buy & Download" call-to-action that opens the pricing popup
// (components/layout/NestingPurchaseRequired.jsx) — matching the server-side
// layout_download gate, which would 403 a real download for these users.
//
// Still dispatches layouts.download_buttons_ready on mount, exactly like
// CanDownload, so the default-dimension nesting preview renders behind the popup.
const BuyAndDownload = ({}) => {
  useEffect(() => {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('layouts.download_buttons_ready', {}));
    }, 250);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('layouts.nesting_purchase_required', {}));
  };

  return (
    <div className="downloadButtonscontainer">
      <div className="inner">
        <div className="child">
          <button className="btn btn-default btn-lg download-btn buy-and-download" onClick={handleClick}>
            <img className="downloadIcon" src={window.dxf_icon} />
            <img className="downloadIcon" src={window.svg_icon} />
            <img className="downloadIcon" src={window.pdf_icon} />
            <span>{t('layouts.buy_and_download')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuyAndDownload;
